import apiClient from '../api/client';

export const login = async (email, password) => {
  const { data } = await apiClient.post('/admin/login', { email, password });
  return data;
};

export const getCurrentAdmin = async () => {
  const { data } = await apiClient.get('/admin/me');
  return data;
};

export const changePassword = async (currentPassword, newPassword) => {
  const { data } = await apiClient.post('/admin/change-password', {
    current_password: currentPassword,
    new_password: newPassword
  });
  return data;
};
